<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-28 18:59:43
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-30 12:26:50
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\src\index\index.vue
-->
<template>
  <el-container class="patient-list-box"> 
    <div class="headerCom"> 
      <publicBreadCrumb :breadList="breadList"/>
      <publicExpandSearch padBottom="0px" :searchList='searchList' :searchEnd='searchEnd' :rightEventList="rightEventList"   @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'>
      </publicExpandSearch> 
    </div>
    <el-main style="padding-top: 0;">
      <div class="table-patient-manage">
        <BaseTable
          :data="tableData"
          :column="tableListConfig"
          pagination
          :auto-scroll="true"
          :total="totalPage"
          :page.sync="searchParams.current"
          :limit.sync="searchParams.size"
          @pagination="getList"
        >
        </BaseTable>
      </div>
    </el-main>
    <el-dialog
      title="监护人信息"
      :visible.sync="guardianVisible"
      width="20%"
      :before-close="handleClose"
      center
      class="guardian-dialog"
    >
      <el-form
        ref="form"
        :model="guardianVO"
        label-suffix=":"
        label-position="right"
        label-width="100px"
        class="guardian-form"
      >
        <el-form-item label="姓名">
          <p>{{ guardianVO.name }}</p>
        </el-form-item>
        <el-form-item label="证件类型">
          <p>{{ guardianVO.certificate }}</p>
        </el-form-item>
        <el-form-item label="证件号">
          <p>{{ guardianVO.idNumber }}</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="guardianVisible = false"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import local from "../../../../utils/local";
import { apiPatientV3Page } from "../../api";
import HeaderSearch from "../../components/HeaderSearch";

export default {
  name: "patientManageList",
  data() {
    return {
      breadList:[{name:'病人管理'},{name:'病人管理'}],
      searchList: [
      {
          label: "搜索项",
          paramName: "type",
          inputType: "select",
          remote: false,
          optionData: [
          {
          label: "姓名",
          value: 1
        },
        {
          label: "微信名",
          value: 2
        },
        {
          label: "手机号",
          value: 3
        },
        {
          label: "证件号",
          value: 4
        }
          ]
        },
        {
          label: "关键词搜索你想要的内容",
          paramName: "keyWord",
          inputType: "input",
          maxNum: 20,
          width:'280px'
        },        
      ],
      rightEventList: [],
      searchParams: { 
					current: 1,
					size: 10,
			},
      searchEnd:{}, //保留从其他页面返回时已存在的搜索条件
      // fromDataValue: {
      //   type: 1,
      //   keyWord: ""
      // },
      guardianVisible: false,
      guardianVO: {},
      tableListConfig: [
        {
          label: "编号",
          align: "center",
          prop: "number"
        },
        {
          label: "微信名",
          align: "center",
          prop: "nickName"
        },

        {
          label: "姓名",
          align: "center",
          prop: "name"
        },
        {
          label: "是否实名",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.idCardStatus ? "是" : "否"}
              </span>
            );
          }
        },
        {
          label: "性别",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.sex === 1
                  ? "男"
                  : scope.row.sex === 2
                  ? "女"
                  : "未知"}
              </span>
            );
          }
        },
        {
          label: "年龄",
          align: "center",
          prop: "age"
        },
        {
          label: "手机号",
          align: "center",
          prop: "phone"
        },
        {
          label: "证件类型",
          align: "center",
          prop: "idCardType"
        },
        {
          label: "证件号",
          align: "center",
          prop: "idCard"
        },
        {
          label: "操作",
          align: "center",
          render: (h, scope) => {
            //是否提醒
            return h("div", {}, [
              h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  on: {
                    click: () => {
                      // 存储查询条件
                      local.set(
                        "patientListCon",
                        JSON.stringify({
                          ...this.searchParams
                        })
                      );
                      this.$store.commit("patientInfo", scope.row);
                      // 进入病人管理详情页面
                      this.$router.push({
                        path: "/patientmanage/detail",
                        query: {
                          patientId: scope.row.patientId,
                          userId: scope.row.userId
                        }
                      });
                    }
                  }
                },
                "进入"
              ),
              h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  style: {
                    display: scope.row.guardianStatus ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      // 弹框给出监护人信息
                      this.guardianVisible = true;
                      this.guardianVO = scope.row.guardianVO
                        ? scope.row.guardianVO
                        : {};
                    }
                  }
                },
                "监护人信息"
              ),
            ]);
          }
        }
      ],
      searchParams: {
        current: 1, //页数
        size: 10 //每页多少条
      },
      tableData: [],
      totalPage: 0 //总数
    };
  },
  components: {
    HeaderSearch
  },
  mounted() {
    let { condition } = this.$route.params;
    if (
      condition &&
      (condition.keyWord || condition.current !== 1 || condition.size !== 10)
    ) {
      // this.fromDataValue = {
      //   type: condition.type,
      //   keyWord: condition.keyWord
      // };
      // this.searchParams = {
      //   current: condition.current,
      //   size: condition.size
      // };
      let end = this.$route.params.condition
      this.searchEnd = end
      this.searchParams.current = end.current
      this.searchParams.size = end.size
      this.searchParams = {...this.searchParams,...this.searchEnd}
      
    }
    this.init();
  },
  methods: {
    /**
     * @description: 初始化
     * @param {*}
     * @return {*}
     */

    async init() {
      let {
        code,
        data: { records, total }
      } = await apiPatientV3Page({  ...this.searchParams });
      if (code === 0) {
        console.log(this.searchParams,"this.searchParams");
        this.tableData = records.map(item => {
          return {
            ...item,
            number: item.number ? item.number : "-",
            nickName: item.nickName ? item.nickName : "-",
            name: item.name ? item.name : "-",
            age: item.age ? item.age : "-",
            phone: item.phone ? item.phone : "-",
            idCardType: item.idCardType ? item.idCardType : "-",
            idCard: item.idCard ? item.idCard : "-"
          };
        });
        this.totalPage = total;
      }
    },
    /**
     * @description: 分页
     * @param {*}
     * @return {*}
     */

    getList() {
      this.init();
    },
    /**
     * @description: 筛选条件重置
     * @param {*}
     * @return {*}
     */
    resetHandel(event) {
      this.searchParams = event;
    },
    /**
     * @description: 筛选条件查询
     * @param {*}
     * @return {*}
     */
    inquireHandel(event) {
      this.searchParams = event;
      this.searchParams = {
        current: 1, //页数
        size: 10 //每页多少条
      };
      // 调用患者列表
      this.init();
    },
    /**
     * @description: 过滤用户状态
     * @param {*}
     * @return {*}
     */
    filterTypeHandel(value) {
      switch (value) {
        case 1:
          return "未申请";
        case 2:
          return "已跟进";
        case 3:
          return "评估中";
        case 4:
          return "待确认";
        case 5:
          return "服务中";
        case 6:
          return "已拒绝";
        case 8:
          return "已退款";
        case 12:
          return "已到期";
        default:
          return "未知状态";
      }
    },
    handleClose() {
      this.guardianVisible = false;
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.dialogVisible = true;
        this.dialogStatus = "add";
        this.temp.id = "";
        this.temp.image = "";
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].resetFields();
        }
      }
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
			this.searchParams = { ...obj, ...this.searchParams };   
      console.log(this.searchParams,"this.searchParams");
      this.init();
    }
  }
};
</script>
<style scoped lang="less">
.patient-list-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  .guardian-dialog {
    .guardian-form {
      // font-weight: bold;
      color: #000000;
      /deep/.el-form-item__label {
        color: #000000;
        font-size: 16px;
      }
      /deep/.el-form-item__content {
        p {
          font-size: 16px;
        }
      }
    }
    /deep/.el-dialog__footer {
      padding-bottom: 45px;
      padding-top: 0;
    }
  } 
  
    .table-patient-manage {
      width: 100%;
      padding: 16px;
      background: #ffffff;
    }
}
</style>
